import React from 'react'

const NavigationLoader = () => {
  const LOADING_SKELETON_ITEMS = [
    { className: ' opacity-100  w-3/4' },
    { className: 'opacity-85 w-full' },
    { className: ' opacity-75 w-2/3' },
    { className: ' opacity-70 w-4/5' },
    { className: ' opacity-65 w-5/6' },
    { className: ' opacity-55 w-1/2' },
    { className: ' opacity-40 w-3/4' },
    { className: ' opacity-20 w-full' }
  ] as const

  return (
    <div className='flex flex-col gap-3 w-full pl-4 pr-8 py-2'>
      {LOADING_SKELETON_ITEMS.map((item, index) => (
        <div key={index} className={`${item.className} h-4 py-1 bg-zinc-200 rounded-full animate-pulse`} />
      ))}
    </div>
  )
}

export default NavigationLoader
